import { useMemo } from 'react';
import { getFullAPIFileURL } from '../../common/getFullAPIFileURL';
import { useGetMusicVideoEditorQuery } from '../../musicVideoEditor/musicVideoEditorApi';
import type { DirectedSongInfo } from '../DirectedVideoContext';

/**
 * The song of the wizard: the title, the cover, the length, the song map and the lyrics. It reads
 * the editor answer of the song (`GET .../music-video/:catalogItemUuid`, cached for the editor too),
 * which holds every fact the director reads.
 */
export function useDirectedSong(accountId: number, catalogItemUuid: string) {
  const query = useGetMusicVideoEditorQuery({ accountId, catalogItemUuid });
  const { data } = query;
  const song = useMemo((): DirectedSongInfo | undefined => {
    if (data === undefined) {
      return undefined;
    }
    return {
      title: data.song.title,
      artistName: data.song.artistName,
      artworkUrl: data.song.artworkUrl === null ? null : getFullAPIFileURL(data.song.artworkUrl),
      durationSec: data.song.durationSec,
      bpm: data.songMap?.bpm ?? null,
      sections: data.songMap?.sections ?? [],
      lyricsStatus: data.lyrics.status,
      lyricLineCount: data.lyrics.lines.length,
    };
  }, [data]);
  return { song, error: query.error, refetch: query.refetch };
}
